// extracted by mini-css-extract-plugin
export default {"control":"Input_control__cLYAY"};